import { message } from "antd";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
export type responseObject = {
  statusCode: number;
  data: any;
  message: string;
};
export function convertErrorResponseToMessage(
  error: any,
  data: any = []
): responseObject {
  if (error instanceof AxiosError) {
    const statusCode: number =
      error.response?.status === undefined ? 500 : error.response?.status;

    const message = getErrorRespCodeMessage(statusCode);
    return { statusCode: statusCode, data: data, message: message };
  } else {
    return { statusCode: 500, data: [], message: getErrorRespCodeMessage(500) };
  }
}
export function convertResponseToMessage(
  status: number,
  message: string,
  data: any
): responseObject {
  return { statusCode: status, data: data, message: message };
}

function getErrorRespCodeMessage(code: number) {
  switch (code) {
    case 401:
      return "Auth Token has expired. You need to login again";
    default:
      return "Unknown Error. Please refresh the page and try again later";
  }
}

export function showToastType(message: string, status: number) {
  switch (status) {
    case 401:
      return toast.error(message);
    case 200:
    case 201:
      return toast.success(message);
    default:
      return toast.error(
        "Unexpected error occured. Please refresh the page or try again later"
      );
  }
}

export function checkIfStringIsEmpty(checkString: string) {
  return checkString !== undefined && checkString.length === 0;
}

export function extractMessageContentsFromWsResponse(message: any) {
  let jsonMessage = JSON.parse(message);
  if (
    jsonMessage !== undefined &&
    jsonMessage["command"] !== undefined &&
    jsonMessage["command"] === "MESSAGE"
  ) {
    return jsonMessage.body;
  }
  return {};
}
